import { CaseListingStoreState } from 'app/area/case-report/case-listing/types-store';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { reportIdToReportCategoryId } from 'app/area/case-report/case-listing/report-to-category-mapping';

export const reportCategory = (state: CaseState | CaseListingStoreState, uiEngineProps: ConnectedComponentProps, appState:any) => {
  const report = uiEngineProps?.hostProps?.()?.selectedReport;

  return {
    reportCategory: reportIdToReportCategoryId(report)
  };
};
